import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
import { isError } from "../utils/index.js";
import { PollingEventSubscriber } from "./subscriber-polling.js";
function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}
/**
 *  Some backends support subscribing to events using a Filter ID.
 *
 *  When subscribing with this technique, the node issues a unique
 *  //Filter ID//. At this point the node dedicates resources to
 *  the filter, so that periodic calls to follow up on the //Filter ID//
 *  will receive any events since the last call.
 *
 *  @_docloc: api/providers/abstract-provider
 */
var _provider = /*#__PURE__*/new WeakMap();
var _filterIdPromise = /*#__PURE__*/new WeakMap();
var _poller = /*#__PURE__*/new WeakMap();
var _running = /*#__PURE__*/new WeakMap();
var _network = /*#__PURE__*/new WeakMap();
var _hault = /*#__PURE__*/new WeakMap();
var _poll = /*#__PURE__*/new WeakSet();
var _teardown = /*#__PURE__*/new WeakSet();
export var FilterIdSubscriber = /*#__PURE__*/function () {
  /**
   *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
   *  and [[_emitResults]] to setup the subscription and provide the event
   *  to the %%provider%%.
   */
  function FilterIdSubscriber(provider) {
    _classCallCheck(this, FilterIdSubscriber);
    _classPrivateMethodInitSpec(this, _teardown);
    _classPrivateMethodInitSpec(this, _poll);
    _classPrivateFieldInitSpec(this, _provider, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _filterIdPromise, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _poller, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _running, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _network, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _hault, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _provider, provider);
    _classPrivateFieldSet(this, _filterIdPromise, null);
    _classPrivateFieldSet(this, _poller, _classPrivateMethodGet(this, _poll, _poll2).bind(this));
    _classPrivateFieldSet(this, _running, false);
    _classPrivateFieldSet(this, _network, null);
    _classPrivateFieldSet(this, _hault, false);
  }
  /**
   *  Sub-classes **must** override this to begin the subscription.
   */
  _createClass(FilterIdSubscriber, [{
    key: "_subscribe",
    value: function _subscribe(provider) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */
  }, {
    key: "_emitResults",
    value: function _emitResults(provider, result) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */
  }, {
    key: "_recover",
    value: function _recover(provider) {
      throw new Error("subclasses must override this");
    }
  }, {
    key: "start",
    value: function start() {
      if (_classPrivateFieldGet(this, _running)) {
        return;
      }
      _classPrivateFieldSet(this, _running, true);
      _classPrivateMethodGet(this, _poll, _poll2).call(this, -2);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!_classPrivateFieldGet(this, _running)) {
        return;
      }
      _classPrivateFieldSet(this, _running, false);
      _classPrivateFieldSet(this, _hault, true);
      _classPrivateMethodGet(this, _teardown, _teardown2).call(this);
      _classPrivateFieldGet(this, _provider).off("block", _classPrivateFieldGet(this, _poller));
    }
  }, {
    key: "pause",
    value: function pause(dropWhilePaused) {
      if (dropWhilePaused) {
        _classPrivateMethodGet(this, _teardown, _teardown2).call(this);
      }
      _classPrivateFieldGet(this, _provider).off("block", _classPrivateFieldGet(this, _poller));
    }
  }, {
    key: "resume",
    value: function resume() {
      this.start();
    }
  }]);
  return FilterIdSubscriber;
}();
/**
 *  A **FilterIdSubscriber** for receiving contract events.
 *
 *  @_docloc: api/providers/abstract-provider
 */
function _poll2(_x7) {
  return _poll3.apply(this, arguments);
}
function _poll3() {
  _poll3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(blockNumber) {
    var filterId, network, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          // Subscribe if necessary
          if (_classPrivateFieldGet(this, _filterIdPromise) == null) {
            _classPrivateFieldSet(this, _filterIdPromise, this._subscribe(_classPrivateFieldGet(this, _provider)));
          }
          // Get the Filter ID
          filterId = null;
          _context5.prev = 3;
          _context5.next = 6;
          return _classPrivateFieldGet(this, _filterIdPromise);
        case 6:
          filterId = _context5.sent;
          _context5.next = 13;
          break;
        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](3);
          if (!(!isError(_context5.t0, "UNSUPPORTED_OPERATION") || _context5.t0.operation !== "eth_newFilter")) {
            _context5.next = 13;
            break;
          }
          throw _context5.t0;
        case 13:
          if (!(filterId == null)) {
            _context5.next = 17;
            break;
          }
          _classPrivateFieldSet(this, _filterIdPromise, null);
          _classPrivateFieldGet(this, _provider)._recoverSubscriber(this, this._recover(_classPrivateFieldGet(this, _provider)));
          return _context5.abrupt("return");
        case 17:
          _context5.next = 19;
          return _classPrivateFieldGet(this, _provider).getNetwork();
        case 19:
          network = _context5.sent;
          if (!_classPrivateFieldGet(this, _network)) {
            _classPrivateFieldSet(this, _network, network);
          }
          if (!(_classPrivateFieldGet(this, _network).chainId !== network.chainId)) {
            _context5.next = 23;
            break;
          }
          throw new Error("chaid changed");
        case 23:
          if (!_classPrivateFieldGet(this, _hault)) {
            _context5.next = 25;
            break;
          }
          return _context5.abrupt("return");
        case 25:
          _context5.next = 27;
          return _classPrivateFieldGet(this, _provider).send("eth_getFilterChanges", [filterId]);
        case 27:
          result = _context5.sent;
          _context5.next = 30;
          return this._emitResults(_classPrivateFieldGet(this, _provider), result);
        case 30:
          _context5.next = 35;
          break;
        case 32:
          _context5.prev = 32;
          _context5.t1 = _context5["catch"](0);
          console.log("@TODO", _context5.t1);
        case 35:
          _classPrivateFieldGet(this, _provider).once("block", _classPrivateFieldGet(this, _poller));
        case 36:
        case "end":
          return _context5.stop();
      }
    }, _callee5, this, [[0, 32], [3, 9]]);
  }));
  return _poll3.apply(this, arguments);
}
function _teardown2() {
  var _this2 = this;
  var filterIdPromise = _classPrivateFieldGet(this, _filterIdPromise);
  if (filterIdPromise) {
    _classPrivateFieldSet(this, _filterIdPromise, null);
    filterIdPromise.then(function (filterId) {
      _classPrivateFieldGet(_this2, _provider).send("eth_uninstallFilter", [filterId]);
    });
  }
}
var _event = /*#__PURE__*/new WeakMap();
export var FilterIdEventSubscriber = /*#__PURE__*/function (_FilterIdSubscriber) {
  _inherits(FilterIdEventSubscriber, _FilterIdSubscriber);
  var _super = _createSuper(FilterIdEventSubscriber);
  /**
   *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
   *  listening for %%filter%%.
   */
  function FilterIdEventSubscriber(provider, filter) {
    var _this;
    _classCallCheck(this, FilterIdEventSubscriber);
    _this = _super.call(this, provider);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _event, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(_assertThisInitialized(_this), _event, copy(filter));
    return _this;
  }
  _createClass(FilterIdEventSubscriber, [{
    key: "_recover",
    value: function _recover(provider) {
      return new PollingEventSubscriber(provider, _classPrivateFieldGet(this, _event));
    }
  }, {
    key: "_subscribe",
    value: function () {
      var _subscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider) {
        var filterId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return provider.send("eth_newFilter", [_classPrivateFieldGet(this, _event)]);
            case 2:
              filterId = _context.sent;
              return _context.abrupt("return", filterId);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _subscribe(_x) {
        return _subscribe2.apply(this, arguments);
      }
      return _subscribe;
    }()
  }, {
    key: "_emitResults",
    value: function () {
      var _emitResults2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(provider, results) {
        var _iterator, _step, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(results);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  result = _step.value;
                  provider.emit(_classPrivateFieldGet(this, _event), provider._wrapLog(result, provider._network));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _emitResults(_x2, _x3) {
        return _emitResults2.apply(this, arguments);
      }
      return _emitResults;
    }()
  }]);
  return FilterIdEventSubscriber;
}(FilterIdSubscriber);
/**
 *  A **FilterIdSubscriber** for receiving pending transactions events.
 *
 *  @_docloc: api/providers/abstract-provider
 */
export var FilterIdPendingSubscriber = /*#__PURE__*/function (_FilterIdSubscriber2) {
  _inherits(FilterIdPendingSubscriber, _FilterIdSubscriber2);
  var _super2 = _createSuper(FilterIdPendingSubscriber);
  function FilterIdPendingSubscriber() {
    _classCallCheck(this, FilterIdPendingSubscriber);
    return _super2.apply(this, arguments);
  }
  _createClass(FilterIdPendingSubscriber, [{
    key: "_subscribe",
    value: function () {
      var _subscribe3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(provider) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return provider.send("eth_newPendingTransactionFilter", []);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function _subscribe(_x4) {
        return _subscribe3.apply(this, arguments);
      }
      return _subscribe;
    }()
  }, {
    key: "_emitResults",
    value: function () {
      var _emitResults3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(provider, results) {
        var _iterator2, _step2, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(results);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  result = _step2.value;
                  provider.emit("pending", result);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function _emitResults(_x5, _x6) {
        return _emitResults3.apply(this, arguments);
      }
      return _emitResults;
    }()
  }]);
  return FilterIdPendingSubscriber;
}(FilterIdSubscriber);